var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('router-view',{key:_vm.identifier,on:{"triggerIdentifier":_vm.triggerIdentifier}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }